import { render, staticRenderFns } from "./overviewCompany.vue?vue&type=template&id=27383158&scoped=true&"
import script from "./overviewCompany.vue?vue&type=script&lang=js&"
export * from "./overviewCompany.vue?vue&type=script&lang=js&"
import style0 from "./overviewCompany.vue?vue&type=style&index=0&id=27383158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27383158",
  null
  
)

export default component.exports